import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DashboardQueries } from '../../../../cp/shared/enums/DashboardQueries';
import { widgetFilters } from '../../../shared/enums/widgetFilters';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';

@Component({
  selector: 'cp-dispatch-review-lite',
  templateUrl: './dispatch-review-lite.component.html',
  styleUrls: ['./dispatch-review-lite.component.scss']
})
export class DispatchReviewLiteComponent implements OnInit {

    constructor() { }

    @Input() chartType: string;
    @Input() inputSearchParams: WidgetSearch;
    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();
    @Output() searchParams = new EventEmitter<WidgetSearch>(true);

    widgetQuery: DashboardQueries = DashboardQueries.dispatchReviewLite;
    chartSearchFilters: widgetFilters[] = [
        widgetFilters.status,
        widgetFilters.class,
        widgetFilters.svcMgr,
        widgetFilters.priority,
        widgetFilters.technicians,
        widgetFilters.onCallRegion
    ];

    ngOnInit() {
    }

    changeLoader(e) {
        this.loaderState.emit(e);
    }

    changeErrorLoader(e) {
        this.loaderErrorState.emit(e);
    }

    setSearchParams(searchParams: WidgetSearch) {
        this.searchParams.emit(searchParams);
    }
}
